export const IconEyeSlashFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconEyeSlashFilled_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconEyeSlashFilled_svg__a)">
        <path d="m19.1 21.9-3.5-3.45A12 12 0 0 1 12 19q-3.35 0-6.125-1.8t-4.35-4.75a1.909 1.909 0 0 1-.187-1.437q.062-.238.187-.463.55-.975 1.175-1.9T4.15 7L2.075 4.9a.93.93 0 0 1-.275-.688q0-.412.3-.712a.95.95 0 0 1 .7-.275q.425 0 .7.275l17 17q.275.275.288.688a.93.93 0 0 1-.288.712.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275M12 16q.274 0 .525-.025a2.7 2.7 0 0 0 .5-.1l-5.4-5.4q-.075.25-.1.5a5 5 0 0 0-.025.525q0 1.875 1.312 3.188Q10.125 16 12 16m0-12q3.35 0 6.137 1.812a12.75 12.75 0 0 1 4.363 4.763q.125.2.188.438.062.237.062.487t-.05.488a1.3 1.3 0 0 1-.175.437q-.475.925-1.062 1.75t-1.313 1.55a1.05 1.05 0 0 1-.825.325 1.23 1.23 0 0 1-.825-.375l-2-2a.8.8 0 0 1-.225-.413 1 1 0 0 1 .025-.487 5 5 0 0 0 .15-.625q.05-.3.05-.65 0-1.875-1.312-3.188Q13.875 7 12 7q-.35 0-.65.05a5 5 0 0 0-.625.15 1 1 0 0 1-.5.025A.8.8 0 0 1 9.8 7l-.825-.825q-.474-.475-.313-1.1.163-.625.788-.8.625-.125 1.263-.2T12 4m1.975 5.65q.275.325.463.713.187.387.237.812.026.2-.15.275-.175.075-.325-.075l-2.05-2.05Q12 9.175 12.088 9a.3.3 0 0 1 .287-.175q.475.05.875.262t.725.563" />
      </g>
    </svg>
  );
};
